import { CompanionError } from '../_internal/error/CompanionError';
import { getConfigValueOrThrow } from '../config';
import { getCurrentSessionToken } from '../session/cache';
import * as Communication from '../utils/communication/module';
import { joinUrlGetHref } from './util';
export function put(path, config) {
    config = _parseRequestConfig(config);
    return Communication.httpPut(Object.assign(Object.assign({}, config), { url: _getEndpoint(path) }));
}
export function patch(path, config) {
    config = _parseRequestConfig(config);
    return Communication.httpPatch(Object.assign(Object.assign({}, config), { url: _getEndpoint(path) }));
}
export function upload(url, config) {
    config = _parseRequestConfig(Object.assign(Object.assign({}, config), { headers: Object.assign({ 
            // Default to this Content-Type header for uploads
            'Content-Type': 'multipart/form-data' }, config === null || config === void 0 ? void 0 : config.headers), requiresAuth: false }));
    return Communication.httpUpload(Object.assign(Object.assign({}, config), { url }));
}
export function uploadS3(url, config) {
    config = _parseRequestConfig(Object.assign(Object.assign({}, config), { requiresAuth: false }));
    return Communication.httpUploadS3(Object.assign(Object.assign({}, config), { url }));
}
export function post(path, config) {
    config = _parseRequestConfig(config);
    return Communication.httpPost(Object.assign(Object.assign({}, config), { url: _getEndpoint(path) }));
}
export function list(path, config) {
    config = _parseRequestConfig(config);
    return Communication.httpGet(Object.assign(Object.assign({}, config), { url: _getEndpoint(path) }));
}
export function remove(path, config) {
    config = _parseRequestConfig(config);
    return Communication.httpDelete(Object.assign(Object.assign({}, config), { url: _getEndpoint(path) }));
}
export function get(path, config) {
    config = _parseRequestConfig(config);
    return Communication.httpGet(Object.assign(Object.assign({}, config), { url: _getEndpoint(path) }));
}
/**
 * Extract the authentication token from the session and
 * attach it as an authorization header for requests that require authorization.
 *
 * In case authorization is not required, nothing is changed on the headers object.
 */
function _parseRequestConfig(config) {
    config = Object.assign({ 
        // Default to true
        requiresAuth: typeof (config === null || config === void 0 ? void 0 : config.requiresAuth) === 'undefined' }, config);
    if (config.requiresAuth) {
        const token = getCurrentSessionToken();
        if (!token) {
            throw new CompanionError({
                error: new Error(`Could not parse request config: No valid auth token provided. Can't attach required authorization header to request.`),
                code: 'AUTH_TOKEN_INVALID',
            });
        }
        // Add Authorization header
        config = Object.assign(Object.assign({}, config), { headers: Object.assign(Object.assign({}, config.headers), { Authorization: token }) });
    }
    if (config.useJson === false) {
        config = Object.assign(Object.assign({}, config), { headers: Object.assign(Object.assign({}, config.headers), { 'Content-Type': 'application/x-www-form-urlencoded' }) });
    }
    // Remove custom parameters that do not apply to XHR
    config.siteId = undefined;
    config.requiresAuth = undefined;
    config.useJson = undefined;
    return config;
}
_parseRequestConfig.ERR = {
    AUTH_TOKEN_INVALID: 'AUTH_TOKEN_INVALID',
};
/**
 * Retrieve the API URL as set in the config.
 *
 * The configuration is not read out on module import to prevent side effects.
 */
function _getBaseUrl() {
    return getConfigValueOrThrow('API_URL');
}
/**
 * Format the endpoint
 */
function _getEndpoint(path) {
    return joinUrlGetHref(_getBaseUrl(), path);
}
